import { Skeleton } from '#components/ui/skeleton'

export function WorkspaceLoadingSkeleton() {
  return (
    <main
      aria-label="Carregando área de trabalho"
      className="bg-muted/20 min-h-svh px-4 py-6 sm:px-6 lg:px-8"
      role="status"
    >
      <div className="mx-auto flex max-w-6xl flex-col gap-6">
        <div className="flex items-center justify-between gap-4">
          <div className="flex flex-col gap-2">
            <Skeleton className="h-4 w-24" />
            <Skeleton className="h-8 w-56" />
            <Skeleton className="h-4 w-80" />
          </div>
          <Skeleton className="size-9 rounded-md" />
        </div>
        <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-4">
          {Array.from({ length: 4 }, (_, index) => (
            <Skeleton key={index} className="h-32 w-full rounded-xl" />
          ))}
        </div>
        <Skeleton className="h-80 w-full rounded-xl" />
      </div>
    </main>
  )
}
